'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'industry-windows';
var width = 576;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M192 80l0 43.3 0 52.7 48-21.8 80-36.4L368 96l0 27.3 0 25.5 0 27.3 48-21.8 80-36.4L544 96l0 52.7L544 432l0 48-48 0L80 480l-48 0 0-48L32 80l0-48 48 0 64 0 48 0 0 48zm19.9 139.7L144 250.5l0-74.5 0-96L80 80l0 352 416 0 0-261.5L387.9 219.7 320 250.5l0-74.5 0-5.5L211.9 219.7zM208 296l0 80-80 0 0-80 80 0zm120 0l0 80-80 0 0-80 80 0zm40 0l80 0 0 80-80 0 0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;